import { render } from "./SettingsBar.vue?vue&type=template&id=43219b04&ts=true"
import script from "./SettingsBar.vue?vue&type=script&lang=ts"
export * from "./SettingsBar.vue?vue&type=script&lang=ts"

import "./SettingsBar.vue?vue&type=style&index=0&id=43219b04&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__